import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.alamedajiujitsu.com";
const OG_IMAGE = `${SITE}/images/sergio-silva.jpg`;

// Reusable per-page SEO. Improves indexability with unique titles, descriptions,
// canonical URLs, Open Graph tags and optional JSON-LD structured data.
const Seo = ({ title, description, path = "/", image = OG_IMAGE, jsonLd = null, breadcrumb = null }) => {
  const url = `${SITE}${path}`;
  const graphs = [];
  if (jsonLd) graphs.push(jsonLd);
  if (breadcrumb) {
    graphs.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumb.map((b, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: b.name,
        item: `${SITE}${b.path}`,
      })),
    });
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {graphs.map((g, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(g)}</script>
      ))}
    </Helmet>
  );
};

// Person structured data for Professor Sergio Silva (authoritative credentials).
export const PROFESSOR_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Professor Sergio Silva",
  jobTitle: "Head Instructor",
  description:
    "5th Degree Black Belt in Brazilian Jiu-Jitsu, Black Belt in Judo, former Submission Wrestling World Champion. Teaching martial arts since 1990.",
  worksFor: {
    "@type": "SportsActivityLocation",
    name: "Alameda Brazilian Jiu-Jitsu & Self-Defense Academy",
    address: {
      "@type": "PostalAddress",
      streetAddress: "2227 Mariner Square Loop",
      addressLocality: "Alameda",
      addressRegion: "CA",
      postalCode: "94501",
      addressCountry: "US",
    },
  },
  knowsAbout: ["Brazilian Jiu-Jitsu", "Judo", "Submission Wrestling", "Self-Defense", "Mixed Martial Arts"],
};

export default Seo;
